import { render, staticRenderFns } from "./Recommended.vue?vue&type=template&id=5f4f1ea0&scoped=true"
import script from "./Recommended.vue?vue&type=script&lang=js"
export * from "./Recommended.vue?vue&type=script&lang=js"
import style0 from "./Recommended.vue?vue&type=style&index=0&id=5f4f1ea0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4f1ea0",
  null
  
)

export default component.exports